import { forwardRef, useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';

import useOnScreen from '../../hooks/useOnScreen';

const ConfiguratorSection = forwardRef(({ id, title, onActiveLinkIdChange, children }, ref) => {
    const isOnScreen = useOnScreen(ref);

    useEffect(() => {
        if (isOnScreen) {
            onActiveLinkIdChange(id);
        }
    }, [isOnScreen, id, onActiveLinkIdChange]);

    return (
        <SectionWrapper id={id} ref={ref}>
            {title}
            {children}
        </SectionWrapper>
    );
});

const SectionWrapper = styled(Box)`
    width: 100%;
    height: 500px;
    border-bottom: 1px solid var(--chakra-colors-gray-200);
`;

export default ConfiguratorSection;
